import { useBlogTheme } from '@/hooks/useBlogTheme';

export const GradientHeading = ({ textArr, normalText, italicText }) => {
  const { isBlogLightTheme } = useBlogTheme();

  const gradientClass = isBlogLightTheme
    ? 'text-black'
    : 'bg-clip-text bg-gradient-to-r from-[#1FBCCB] via-[#A7ECEF] to-white text-transparent';

  const hasTextArr = Array.isArray(textArr) && textArr.length > 0;

  return (
    <p
      className="max-w-[800px] mx-auto text-[30px] md:text-[50px] text-center leading-none md:leading-[60px]"
      style={{
        textShadow: isBlogLightTheme ? 'none' : '0px 0px 29px #1FBCCB66',
      }}
    >
      {hasTextArr ? (
        textArr.map((item, index) => {
          if (item.style === 'italic') {
            return (
              <span
                key={index}
                className={`font-instrument-serif italic ${gradientClass}`}
              >
                {item.text}
              </span>
            );
          }

          return (
            <span key={index} className={`font-inter-tight ${gradientClass}`}>
              {item.text}
            </span>
          );
        })
      ) : (
        <>
          <span className={`font-inter-tight ${gradientClass}`}>
            {normalText}
          </span>

          <br className="hidden lg:block" />

          <span className={`font-instrument-serif italic ${gradientClass}`}>
            {italicText}
          </span>
        </>
      )}
    </p>
  );
};
